import 'jquery';
import 'slick-carousel';
import isTouchDev from './isTouchDev';
import isIEBrowser from './isIEBrowser';

export default () => {
  $('.js-main-slider').slick({
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow:
        '<button type="button" class="slick-prev" aria-label="button"><img src="./wp-content/themes/murberget/resources/assets/images/arrow-slide.svg" aria-hidden="true" alt="arrow-left"></button>',
    nextArrow:
      '<button type="button" class="slick-next" aria-label="button" aria-hidden="true"><img src="./wp-content/themes/murberget/resources/assets/images/arrow-slide.svg" aria-hidden="true" alt="arrow-right"></button>'
  });

  if (isIEBrowser()) {
    if ($('.main-slider .slick-active').find('video')) {
      $('.main-slider .slick-active')
        .find('video')
        .show();
    }

    $('.main-slider').on('afterChange', function() {
      $('.main-slider .slick-slide:not(.slick-active)').each(() => {
        if ($('.main-slider .slick-active').find('video')) {
          $('.main-slider .slick-active')
            .find('video')
            .hide();
        }
      });
      if ($('.main-slider .slick-active').find('video')) {
        $('.main-slider .slick-active')
          .find('video')
          .show();
      }
    });
  }

  $(document).ready(function() {
    if ($('.main-slider .slick-active').find('video')[0]) {
      $('.main-slider .slick-active')
        .find('video')[0]
        .play();
    }
  });

  $('.main-slider').on('afterChange', function() {
    $('.main-slider .slick-slide:not(.slick-active)').each((i, el) => {
      if ($(el).find('video')[0]) {
        $(el)
          .find('video')[0]
          .pause();
        $(el).find('video')[0].currentTime = 0;
      }
    });
    if ($('.main-slider .slick-active').find('video')[0]) {
      $('.main-slider .slick-active')
        .find('video')[0]
        .play();
    }
  });

  if (!isTouchDev()) {
    $('.main-slider')
      .find('.video-mode .cover-img')
      .hide();
  } else {
    $('.main-slider')
      .find('.video-mode video')
      .hide();
  }

  $('.js-personal-page-slider').slick({
    dots: true,
    arrows: false
  });

  $('.js-search-page-slider').slick({
    dots: true,
    arrows: false
  });
  $('body:not(.post-template-single-digital-exhibition) .js-operations-page-slider').slick({
    dots: true,
    arrows: false
  });
  $('.post-template-single-digital-exhibition .js-operations-page-slider').slick({
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 6000,
  });

  $('.js-search-photo-slider').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-search-photo-slider-nav',
    swipe: false
  });
  $('.js-search-photo-slider-nav').slick({
    slidesToShow: 15,
    slidesToScroll: 1,
    asNavFor: '.js-search-photo-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.js-search-object-slider').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-search-object-slider-nav',
    swipe: false
  });

  $('.js-search-object-slider-nav').slick({
    slidesToShow: 15,
    slidesToScroll: 1,
    asNavFor: '.js-search-object-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.js-search-konst-slider').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-search-konst-slider-nav',
    swipe: false
  });

  $('.js-search-konst-slider-nav').slick({
    slidesToShow: 15,
    slidesToScroll: 1,
    asNavFor: '.js-search-konst-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.js-search-rapporter-slider').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-search-rapporter-slider-nav',
    swipe: false
  });

  $('.js-search-rapporter-slider-nav').slick({
    slidesToShow: 15,
    slidesToScroll: 1,
    asNavFor: '.js-search-rapporter-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.js-search-document-slider').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-search-document-slider-nav',
    swipe: false
  });

  $('.js-search-document-slider-nav').slick({
    slidesToShow: 15,
    slidesToScroll: 1,
    asNavFor: '.js-search-document-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.js-search-filmer-slider').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-search-filmer-slider-nav',
    swipe: false
  });

  $('.js-search-filmer-slider-nav').slick({
    slidesToShow: 15,
    slidesToScroll: 1,
    asNavFor: '.js-search-filmer-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.js-search-noter-slider').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-search-noter-slider-nav',
    swipe: false
  });

  $('.js-search-noter-slider-nav').slick({
    slidesToShow: 15,
    slidesToScroll: 1,
    asNavFor: '.js-search-noter-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('body:not(.post-template-single-digital-exhibition) .js-event-galery').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-event-galery-nav',
    swipe: false
  });
  $('body:not(.post-template-single-digital-exhibition) .js-event-galery-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.js-event-galery',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.post-template-single-digital-exhibition .js-event-galery').slick({
    dots: false,
    arrows: true,
    asNavFor: '.js-event-galery-nav',
    swipe: false
  });
  $('.post-template-single-digital-exhibition .js-event-galery-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.js-event-galery',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });
};



// WEBPACK FOOTER //
// ./scripts/modules/slider.js